import React, { useContext, useEffect, useMemo, useState, useCallback, useRef } from "react";
import Header from "components/common/Header/Header";
import TableHeader from "components/common/Table/TableHeader";
import { LoginContext } from "helpers/LoginContext";
import { BiExit } from "react-icons/bi";
import {
  HiOutlineClipboardDocumentCheck,
  HiOutlineCurrencyDollar,
  HiOutlineDocumentText,
} from "react-icons/hi2";
import SideBarNew from "components/common/SideBar/SideBarNew";
import { useNavigate } from "react-router";
import { apiGetRequest, apiPutRequest } from "helpers/Requests";
import {
  isRequestCancelled,
  replaceAbortController,
} from "Utils/requestCancel";
import {
  URL_ROSTERING_INVOICE_STATUS_UPDATE,
  URL_ROSTER_INVOICES_LIST,
} from "store/services/URL";
import RosterInvoicesTable from "./RosterInvoicesTable";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import SelectOption from "components/common/Select/Select";
import SelectBox from "components/common/DropDownWithIocns/DropDown";
import CheckBox from "components/common/checkBox/checkbox";
import { connect, useDispatch } from "react-redux";
import { getParticipantsList, getSpSetting } from "store/selector/sp.selector";
import { getSPParticipantsListRequest } from "store/actions/sp.actions";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { roleAccess, usePermissionsVersion } from "helpers/RolesPermission";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";
import Pagination from "components/common/Pagination";
import { emptyPaginationObj, getParticipantLabel } from "Constants/constant";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import CustomButton from "components/common/Button/CustomButton";
import { cloneDeep } from "lodash";
import Xero from "assets/images/xero.png";
import { addMonths, capitalizeWords, classNames } from "Utils/utils";
import moment from "moment";
import {
  formatShiftBillingCurrency,
  summarizeRosterInvoiceListPage,
} from "../UpdatedTimeSheet/TimeSheetDetailsSection/TabSection/NewCodeAllocation/v5BillingUtils";
import { FiArrowUpRight } from "react-icons/fi";
import { getParticipantUpdatePusherReceivedSelector } from "store/selector/participant.selector";
import { resetparticipantUpdatePusher } from "store/actions/participant.actions";
import DateRangePickerNew from "../../../components/common/DateRangePicker/DateRangePickerNew";
import Breadcrumb from "../../../components/common/Breadcrumb";
import {
  ROSTERING_INVOICING_BREADCRUMB,
  ROSTERING_INVOICING_BREADCRUMB_PAGES
} from "../../../Constants/BreadcrumbConstant";
import InvoicingWorkflowLayout, {
  InvoicingWorkflowFilterField,
} from "./components/InvoicingWorkflowLayout";
// import PopoverContainer from "components/common/Popover/PopoverContainer";

const RosterInvoicing = ({
  getParticipantList,
  spParticipants,
  participantUpdatePusherReceived,
  settings,
}) => {
  const navigate = useNavigate();
  const { sideBarPadding } = useContext(LoginContext);
  const permissionsVersion = usePermissionsVersion();
  const canAccessCreateInvoice = useMemo(
    () =>
      roleAccess(
        [],
        PERMISSION_KEYS.ROSTER_INVOICE,
        PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.CREATE
      ),
    [permissionsVersion]
  );
  const participantLabel = getParticipantLabel(settings?.care_sector, false);
  const participantLabelPlural = getParticipantLabel(settings?.care_sector, true);
  const participantNameLabel = participantLabel + " Name";

  const dispatch = useDispatch();
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);

  const [rosterInvoices, setRosterInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [checkboxes, setCheckboxes] = useState([]);
  const [selectedAmount, setSelectedAmount] = useState(0);
  const [updatedAction, setUpdatedAction] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loader, setLoader] = useState(false);
  const listAbortRef = useRef(null);
  const listRequestIdRef = useRef(0);
  const [statusSelect, setStatus] = useState({
    label: "All",
    value: "",
  });

  const [openForNonXeroPts, setOpenForNonXeroPts] = useState([]);

  const [createdFilter, setCreatedFilter] = useState(null);
  const [deliveredFilter, setDeliveredFilter] = useState(null);
  const [perPage, setPerPage] = useState({
    label: "10",
    value: 10,
  });

  const STATUS_VALUES = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Extract Generated",
      value: "Extract Generated",
    },
    {
      label: "Exported to Xero",
      value: "Export to Xero",
    },
    {
      label: "Mark As Paid",
      value: "Mark As Paid",
    },
    {
      label: "Mark As Void",
      value: "Void",
    },
  ];

  const PER_PAGE_VALUES = [
    {
      label: "10",
      value: 10,
    },
    {
      label: "20",
      value: 20,
    },
    {
      label: "50",
      value: 50,
    },
    {
      label: "100",
      value: 100,
    },
    {
      label: "150",
      value: 150,
    },
  ];

  useEffect(() => {
    const filters = {
      page: 1,
      per_page: 1000,
      search: null,
    };

    getParticipantList({ filters, bodyFilter: null });
  }, []);

  useEffect(() => {
    if (
      rosterInvoices &&
      checkboxes &&
      checkboxes?.length ===
        rosterInvoices?.filter((item) => item?.status !== "Void").length &&
      rosterInvoices?.length !== 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [checkboxes]);

  const participantList = useMemo(() => {
    const participants = spParticipants?.participant?.data;
    if (!participants) return undefined;

    return participants
      .slice()
      .sort((a, b) => {
        const nameA = `${capitalizeWords(a?.first_name)} ${capitalizeWords(a?.last_name)}`
          .trim()
          .toLowerCase();
        const nameB = `${capitalizeWords(b?.first_name)} ${capitalizeWords(b?.last_name)}`
          .trim()
          .toLowerCase();
        return nameA.localeCompare(nameB);
      })
      .map((item) => ({
        label: `${capitalizeWords(item?.first_name)} ${capitalizeWords(item?.last_name)}`,
        value: item?.id,
      }));
  }, [spParticipants]);

  const checkboxSet = useMemo(() => new Set(checkboxes), [checkboxes]);

  const handleUpdateParticipantXeroContactId = (ptObj) => {
    const prevRosterInvoices = cloneDeep(rosterInvoices);
    if (ptObj?.pt_uuid) {
      prevRosterInvoices.forEach((invoice) => {
        if (invoice?.participant?.uuid === ptObj.pt_uuid) {
          invoice.participant.xero_contact_id = ptObj.xero_contact_id;
        }
      });
    }
    setRosterInvoices([...prevRosterInvoices]);
  };

  useEffect(() => {
    if (participantUpdatePusherReceived && rosterInvoices?.length > 0) {
      handleUpdateParticipantXeroContactId(participantUpdatePusherReceived);
    }
    dispatch(resetparticipantUpdatePusher());
  }, [participantUpdatePusherReceived]);

  const handleCheckboxChange = useCallback((e, uuid) => {
    const invoice = rosterInvoices.find((inv) => inv.uuid === uuid);
    const invoiceAmount = parseFloat(invoice?.total_amount ?? 0);
    const safeAmount = Number.isNaN(invoiceAmount) ? 0 : invoiceAmount;

    setCheckboxes((prev) => {
      const filteredList = prev.filter((c) => c !== uuid);
      if (e) {
        filteredList.push(uuid);
      }
      return filteredList;
    });

    if (e) {
      setSelectedAmount((prev) => prev + safeAmount);
    } else {
      setSelectedAmount((prev) => Math.max(0, prev - safeAmount));
    }
  }, [rosterInvoices]);

  const toggleCheckboxes = (val) => {
    if (val) {
      const selectable = rosterInvoices?.filter((item) => item?.status !== "Void") ?? [];
      const total = selectable.reduce(
        (sum, inv) => sum + (parseFloat(inv?.total_amount ?? 0) || 0),
        0
      );
      setSelectedAmount(total);
      setCheckboxes(selectable.map((el) => el.uuid));
    } else {
      setSelectedAmount(0);
      setCheckboxes([]);
    }
  };

  const clearInvoiceSelection = () => {
    setCheckboxes([]);
    setSelectedAmount(0);
  };

  const buildFetchFilters = (overrides = {}) => ({
    page: paginationObj.page,
    per_page: perPage?.value,
    status: statusSelect?.value,
    pt_id: selectedClient?.value,
    created_start: createdFilter?.fromDate,
    created_end: createdFilter?.toDate,
    delivered_start: deliveredFilter?.fromDate,
    delivered_end: deliveredFilter?.toDate,
    ...overrides,
  });

  const buildListingQueryString = (filter = {}) => {
    const params = new URLSearchParams();
    params.set("per_page", String(filter.per_page ?? 10));
    params.set("page", String(filter.page ?? 1));
    if (filter.status) params.set("status", filter.status);
    if (filter.pt_id) params.set("pt_id", filter.pt_id);
    if (filter.created_start) params.set("c_s", filter.created_start);
    if (filter.created_end) params.set("c_e", filter.created_end);
    if (filter.delivered_start) params.set("d_s", filter.delivered_start);
    if (filter.delivered_end) params.set("d_e", filter.delivered_end);
    return params.toString();
  };

  const applyInvoiceListResponse = (paginator) => {
    if (!paginator) return;

    setRosterInvoices(paginator.data ?? []);
    if (!paginator.data?.length) {
      setPaginationObj(emptyPaginationObj);
    } else {
      setPaginationObj((prev) => ({
        ...prev,
        page: paginator.current_page ?? prev.page,
        per_page: paginator.per_page,
        total: paginator.total,
        totalPages: Math.ceil(paginator.total / paginator.per_page),
      }));
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchData(buildFetchFilters({ page: 1 }));
  }, [selectedClient, statusSelect, createdFilter, deliveredFilter, perPage?.value]);

  const fetchData = (filter = {}) => {
    const requestId = ++listRequestIdRef.current;
    listAbortRef.current = replaceAbortController(listAbortRef.current);
    const signal = listAbortRef.current?.signal;

    setLoader(true);
    apiGetRequest(
      `${URL_ROSTER_INVOICES_LIST}?${buildListingQueryString(filter)}`,
      null,
      signal ? { signal } : {}
    )
      .then((res) => {
        if (requestId !== listRequestIdRef.current) return;
        setLoader(false);
        if (res?.status === 200) {
          applyInvoiceListResponse(res?.data?.data);
        }
      })
      .catch((error) => {
        if (isRequestCancelled(error)) return;
        if (requestId !== listRequestIdRef.current) return;
        setLoader(false);
      })
      .finally(() => {
        if (requestId !== listRequestIdRef.current) return;
        setLoader(false);
        setLoading(false);
      });
  };

  useEffect(
    () => () => {
      listRequestIdRef.current += 1;
      try {
        listAbortRef.current?.abort?.();
      } catch {
        // ignore
      }
    },
    []
  );

  useEffect(() => {
    if (updatedAction && checkboxes?.length > 0) {
      if (updatedAction === "xero") {
        const uniqueParticipants = [];
        const seenUuids = new Set();
        for (const invoice of rosterInvoices) {
          const participant = invoice.participant;
          const uuid = participant?.uuid;
          if (
            checkboxes.includes(invoice.uuid) &&
            !participant?.xero_contact_id &&
            uuid &&
            !seenUuids.has(uuid)
          ) {
            seenUuids.add(uuid);
            uniqueParticipants.push(invoice);
          }
        }
        if (uniqueParticipants?.length > 0) {
          setOpenForNonXeroPts([...uniqueParticipants]);
          return;
        }
      }
      handleChangeAction(checkboxes);
    }
  }, [updatedAction]);

  const handleLimit = (selectedCheckboxes = []) => {
    if (selectedCheckboxes?.length === 0) return null;

    if (updatedAction === "xlsx" && selectedCheckboxes?.length > 100) {
        return "Maximum 100 invoices can be selected at a time";
    }
    if (["pdf", "email_invoice", "Email Invoice"].includes(updatedAction) && selectedCheckboxes?.length > 50) {
        return "Maximum 50 invoices can be selected at a time";
    }
    return null;
};

  const getText = (selectedCheckboxes) => {
    if (updatedAction === "provider_paid") {
      return "Are you sure you want to change the status to  Paid";
    } else if (updatedAction === "pdf") {
      return "Are you sure you want to generate pdf file";
    } else if (updatedAction === "xlsx") {
      return "Are you sure you want to generate excel file";
    } else if (updatedAction === "cancelled") {
      return "Are you sure you want to cancel invoice";
    } else if (updatedAction === "email_invoice" || updatedAction === "Email Invoice") {
      return "Are you sure you want to Email Invoice";
    } else if (updatedAction === "Void") {
      return "Are you sure you want to mark as void";
    } else if (updatedAction === "xero") {
      return "Are you sure you want to Export on Xero";
    } else {
      return "Are you sure";
    }
  };

  const getToastMessage = (status, noOfInvoices) => {
    let message = null;
    if (status === "Mark As Paid") {
      message = "Marked ss Paid!";
    } else if (status === "Excel File") {
      message = "Generated Excel!";
    } else if (status === "PDF File") {
      message = "Generated PDF!";
    } else if (status === "Email Invoice") {
      message = "Sent Email!";
    } else if (status === "Cancelled") {
      message = "Cancelled!";
    } else if (status === "Void") {
      message = "Void!";
    } else if (status === "Export to Xero") {
      message = "Exported to Xero!";
    } else {
      message = "Updated!";
    }

    return `Invoice${noOfInvoices > 1 ? "s" : ""} Successfully ${message}`;
  };

  const handleChangeAction = async (selectedCheckboxes = []) => {
    const limitMessage = handleLimit(selectedCheckboxes);
    setUpdatedAction(null);
    if (limitMessage) {
        swal({
            text: limitMessage,
            icon: "warning",
            dangerMode: true,
        });
        return;
    }

       swal({
          title: "Confirm your action?",
          text: `${getText(selectedCheckboxes)}`,
          icon: "",
          buttons: ["No, take me back!", "Yes, go ahead!"],
          className: "",

          cancel: {
            text: "No, take me back!",
            value: null,
            visible: false,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: "Yes, go ahead!",
            value: true,
            visible: true,

            closeModal: true,
          },

          dangerMode: updatedAction === "cancelled" ? true : false,
        }).then((willDelete) => {
          if (willDelete) {
            if (selectedCheckboxes?.length > 0) {
              setLoading(true);
              const status =
                updatedAction === "provider_paid"
                  ? "Mark As Paid"
                  : updatedAction === "xlsx"
                  ? "Excel File"
                  : updatedAction === "pdf"
                  ? "PDF File"
                  : updatedAction === "email_invoice" || updatedAction === "Email Invoice"
                  ? "Email Invoice"
                  : updatedAction === "cancelled"
                  ? "Cancelled"
                  : updatedAction === "Void"
                  ? "Void"
                  : updatedAction === "xero"
                  ? "Export to Xero"
                  : "";
              apiPutRequest(
                `${URL_ROSTERING_INVOICE_STATUS_UPDATE}?${buildListingQueryString(
                  buildFetchFilters()
                )}`,
                {
                  status,
                  uuid: selectedCheckboxes,
                }
              )
                .then((res) => {
                  if (res?.status === 200) {
                    applyInvoiceListResponse(res?.data?.data);
                    setLoading(false);
                    toast.success(
                      getToastMessage(status, selectedCheckboxes?.length)
                    );
                  } else {
                    setLoading(false);
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  console.log({ error });
                  toast.error(error?.message || "Something Went Wrong!");
                });
              clearInvoiceSelection();
              setUpdatedAction("");
            }
          } else {
            clearInvoiceSelection();
            setUpdatedAction("");
          }
        });
  };

  const modalFooterButton = () => (
    <CustomButton
      clickHandler={() => {
        setOpenForNonXeroPts([]);
      }}
      type='button'
      label='Close'
      onClick={() => {
        setOpenForNonXeroPts([]);
        setUpdatedAction("");
      }}
    />
  );

  const pageMetrics = useMemo(
    () => summarizeRosterInvoiceListPage(rosterInvoices),
    [rosterInvoices]
  );

  const filterSummary = useMemo(() => {
    const parts = [];

    if (statusSelect?.value) {
      parts.push(statusSelect.label);
    }

    if (selectedClient?.value) {
      parts.push(selectedClient.label);
    }

    if (createdFilter?.fromDate && createdFilter?.toDate) {
      parts.push(
        `Created ${moment(createdFilter.fromDate).format("D MMM YY")} – ${moment(createdFilter.toDate).format("D MMM YY")}`
      );
    }

    if (deliveredFilter?.fromDate && deliveredFilter?.toDate) {
      parts.push(
        `Delivered ${moment(deliveredFilter.fromDate).format("D MMM YY")} – ${moment(deliveredFilter.toDate).format("D MMM YY")}`
      );
    }

    return parts.join(" · ") || "All invoices";
  }, [statusSelect, selectedClient, createdFilter, deliveredFilter]);

  const totalInvoicesSubValue = useMemo(() => {
    const total = paginationObj.total ?? 0;
    if (!total) return "Adjust filters to find invoices";

    return filterSummary;
  }, [paginationObj.total, filterSummary]);

  const pageInvoiceSubValue = useMemo(() => {
    if (!pageMetrics.pageCount) return "No invoices on this page";

    return `${pageMetrics.pageCount} invoice${
      pageMetrics.pageCount === 1 ? "" : "s"
    } on page`;
  }, [pageMetrics]);

  const selectedInvoiceCard = useMemo(() => {
    if (!checkboxes.length) {
      return {
        value: "—",
        label: "Selected invoice value",
        highlight: false,
      };
    }

    return {
      value: formatShiftBillingCurrency(selectedAmount) ?? "$0.00",
      label: "Selected invoice value",
      highlight: true,
    };
  }, [checkboxes.length, selectedAmount]);

  const workflowStats = useMemo(
    () => [
      {
        icon: HiOutlineDocumentText,
        value: paginationObj.total ?? 0,
        label: "Total invoices",
        subValue: totalInvoicesSubValue,
        iconVariant: "blue",
      },
      {
        icon: HiOutlineCurrencyDollar,
        value:
          formatShiftBillingCurrency(pageMetrics.pageTotalAmount) ?? "$0.00",
        label: "Page invoice value",
        subValue: pageInvoiceSubValue,
        iconVariant: "teal",
      },
      {
        icon: HiOutlineClipboardDocumentCheck,
        value: selectedInvoiceCard.value,
        label: selectedInvoiceCard.label,
        iconVariant: "amber",
        highlight: selectedInvoiceCard.highlight,
      },
    ],
    [
      paginationObj.total,
      totalInvoicesSubValue,
      pageMetrics.pageTotalAmount,
      pageInvoiceSubValue,
      selectedInvoiceCard,
    ]
  );

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col`}
      >
        <main className="h-screen flex-1 bg-[#f1f5f9]">
          <Header
            breadcrumb={
              <Breadcrumb
                  pages={ROSTERING_INVOICING_BREADCRUMB(
                      ROSTERING_INVOICING_BREADCRUMB_PAGES.LIST_ROSTER_INVOICING
                  )}
              />
            }
          />
          <InvoicingWorkflowLayout
            activeStepId="invoices"
            filterTitle="Filter invoices"
            filterGridClass="iw-filter-grid--4"
            stats={workflowStats}
            headerActions={
              canAccessCreateInvoice ? (
                <CustomButton
                  clickHandler={() => navigate("/rostering/create-roster-invoice")}
                  Icon={<BiExit />}
                  label={
                    <span className="whitespace-nowrap">Go to create invoice</span>
                  }
                />
              ) : null
            }
            filterActions={
              <SelectBox
                forRosterInvoicing={true}
                disabled={checkboxes?.length > 0 ? false : true}
                setUpdatedAction={setUpdatedAction}
                allowXeroExport={true}
              />
            }
            filters={
              <>
                <InvoicingWorkflowFilterField label={participantLabel}>
                  <SelectOption
                    placeHolder={`All ${participantLabel}s`}
                    newDesign={true}
                    isClearable={true}
                    isDisabled={loading}
                    cssClass=""
                    name="participant"
                    isSearch={true}
                    data={participantList && participantList}
                    selectedOption={selectedClient}
                    handleChange={(e) => {
                      setSelectedClient(e);
                      clearInvoiceSelection();
                    }}
                    maxHeight="350px"
                  />
                </InvoicingWorkflowFilterField>
                <InvoicingWorkflowFilterField label="Status">
                  <SelectOption
                    placeHolder="All statuses"
                    newDesign={true}
                    isClearable={true}
                    isDisabled={loading}
                    cssClass=""
                    name="status"
                    isSearch={false}
                    data={STATUS_VALUES}
                    selectedOption={statusSelect}
                    handleChange={(e) => {
                      setStatus(e);
                      clearInvoiceSelection();
                    }}
                    maxHeight="350px"
                  />
                </InvoicingWorkflowFilterField>
                <InvoicingWorkflowFilterField label="Created date">
                  <DateRangePickerNew
                    placeholder="Created Date Range"
                    showCalendarIcon={true}
                    isDisabled={loading}
                    handleCancel={() => setCreatedFilter(null)}
                    handleChange={(obj) => {
                      setCreatedFilter(obj);
                      clearInvoiceSelection();
                    }}
                  />
                </InvoicingWorkflowFilterField>
                <InvoicingWorkflowFilterField label="Service delivered">
                  <DateRangePickerNew
                    placeholder="Service Delivered Date Range"
                    showCalendarIcon={true}
                    isDisabled={loading}
                    handleCancel={() => setDeliveredFilter(null)}
                    handleChange={(obj) => {
                      setDeliveredFilter(obj);
                      clearInvoiceSelection();
                    }}
                  />
                </InvoicingWorkflowFilterField>
              </>
            }
          >
            <div className="iw-table-card">
              <div className="iw-table-card-header">
                <div className="iw-table-card-heading">
                  <h2 className="iw-table-card-title">
                    Invoices
                    <span className="iw-table-card-count">
                      ({paginationObj.total ?? 0})
                    </span>
                  </h2>
                  {pageMetrics.pageCount > 0 && (
                    <div className="iw-table-card-summary">
                      <span className="iw-summary-chip iw-summary-chip--value">
                        {formatShiftBillingCurrency(pageMetrics.pageTotalAmount) ??
                          "$0.00"}{" "}
                        on page
                      </span>
                      {checkboxes.length > 0 && (
                        <span className="iw-summary-chip iw-summary-chip--payroll">
                          {checkboxes.length} selected ·{" "}
                          {formatShiftBillingCurrency(selectedAmount) ?? "$0.00"}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="iw-table-scroll is-expanded custom-scroll">
                <table className="min-w-full divide-y divide-gray-200 border-collapse">
                  <thead className="sticky top-0 z-[5] capitalize bg-[#f8fafc]">
                    <tr className="border-b border-gray-200">
                      <th
                          scope="col"
                          className="pl-4 py-3 text-center text-xs font-bold uppercase tracking-wide text-gray-500 bg-[#f8fafc]"
                      >
                        <CheckBox
                            checked={allSelected}
                            handleChange={(e) => {
                              if (
                                  rosterInvoices &&
                                  rosterInvoices?.length > 0
                              ) {
                                setAllSelected(e);
                                toggleCheckboxes(e);
                              }
                            }}
                        />
                      </th>
                      <TableHeader
                          isSort={false}
                          cssClass="normal-case"
                          label={"Invoice #"}
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          isSort={false}
                          label={participantLabel}
                          cssClass="text-center normal-case"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          sortName="created_by"
                          cssClass="text-center normal-case"
                          isSort={false}
                          label={"Created By"}
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          isSort={false}
                          sortName="created-at"
                          cssClass="text-center normal-case"
                          label={"Created Date"}
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          isSort={false}
                          sortName="support_item_no"
                          label={"Service Delivered From"}
                          cssClass="text-center normal-case"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          isSort={false}
                          sortName="created_by"
                          label={"Service Delivered To"}
                          cssClass="text-center normal-case"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          isSort={false}
                          label={"Status"}
                          cssClass="text-center normal-case"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          isSort={false}
                          sortName="client"
                          label={"No. Delivered"}
                          cssClass="text-center normal-case"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          isSort={false}
                          sortName="management_style"
                          label={"Total Value"}
                          cssClass="text-center normal-case"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                      <TableHeader
                          isSort={false}
                          sortName="status"
                          label={"Actions"}
                          cssClass="text-center normal-case"
                          innerCssClass="text-xs font-bold uppercase tracking-wide text-gray-500"
                          blueBg={false}
                      />
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 bg-white">
                  {loading || loader ? (
                      <tr>
                        <td colSpan={11} className="py-16 text-center bg-[#fafbfc]">
                          <CircularLoader
                              classes="flex justify-center items-center"
                              classloader="loader-l"
                          />
                        </td>
                      </tr>
                  ) : rosterInvoices && rosterInvoices?.length > 0 ? (
                      rosterInvoices?.map((item) => (
                          <RosterInvoicesTable
                              item={item}
                              key={item?.uuid}
                              isChecked={checkboxSet.has(item?.uuid)}
                              handleCheckboxChange={handleCheckboxChange}
                          />
                      ))
                  ) : (
                      <tr>
                        <td
                            colSpan={11}
                            className="py-20 text-center text-slate-500"
                        >
                          <strong className="block text-slate-700 mb-1">
                            No invoices found
                          </strong>
                          Adjust your filters to see roster invoices.
                        </td>
                      </tr>
                  )}
                  </tbody>
                </table>
              </div>
              {paginationObj.total > 0 && (
                <div className="iw-table-footer">
                  <Pagination
                      newDesign={true}
                      showPerPageDropdown={true}
                      handleLimitChange={setPerPage}
                      perPageData={PER_PAGE_VALUES}
                      perPageValue={perPage}

                      page={paginationObj.page}
                      activeListLength={rosterInvoices}
                      limit={paginationObj.per_page}
                      totalList={paginationObj.total}
                      handlePagination={(e) => {
                        setPaginationObj((prev) => ({ ...prev, page: e }));
                        fetchData(buildFetchFilters({ page: e }));
                      }}
                      totalPages={paginationObj.totalPages}
                  />
                </div>
              )}
            </div>
          </InvoicingWorkflowLayout>
        </main>
      </div>
      {openForNonXeroPts?.length > 0 && (
          <ModalSkeleton
              isOpen={openForNonXeroPts?.length > 0}
              // closeModal={() => {
              //   setOpenForNonXeroPts([]);
              // }}
              modalFooter={modalFooterButton()}
              cssClass='w-[35%]'
              title='Warning'
              titleCss='!bg-amber-300'
          >
            <>
              <div className='py-2 px-2'>
              <span className='text-gray-500'>
                {`The following ${participantLabelPlural.toLowerCase()} haven’t been set up for Xero
                integration yet. To proceed, you can either click the "Connect
                Xero" button to set them up or unselect ${participantLabelPlural.toLowerCase()} from the
                previous screen.`}
              </span>
              </div>
              <div className='py-2 px-2'>
                <div className='flex flex-col'>
                  <div className='min-w-full'>
                    <div className='shadow ring-1 ring-black ring-opacity-5 md:rounded-lg'>
                      <div className='table-wrp block'>
                        <table className='min-w-full divide-y divide-gray-300'>
                          {/* <thead className='bg-blue-50 capitalize'>
                          <tr>
                            <TableHeader
                              isSort={false}
                              label={participantNameLabel}
                            />
                            <TableHeader isSort={false} label={"Setup Xero"} />
                          </tr>
                        </thead> */}
                          <tbody className='divide-y divide-gray-200 bg-white'>
                          {openForNonXeroPts?.map((item, index) => (
                              <tr
                                  index={index}
                                  className='text-center even:bg-white odd:bg-gray-50'
                              >
                                <td className='capitalize px-3 text-sm text-gray-500 text-start w-[60%]'>
                                <div className='text-gray-500 text-sm'>
                                  {item?.participant?.first_name}{" "}
                                  {item?.participant?.last_name}
                                </div>
                              </td>
                              <td className=' px-3 text-sm text-gray-500 text-end '>
                                <div className='relative'>
                                  {/* <PopoverContainer
                                    cssClass={`text-sm bg-gradient rounded-md bg-black py-1 px-1 rounded text-white z-[50]`}
                                    itemComponent={() => {}}
                                    toolTip={`Setup Xero For This ${participantLabel}.`}
                                  > */}
                                  <span
                                    className={classNames(
                                      "text-gray-700",
                                      "group flex items-center justify-end px-4 py-2 text-sm cursor-pointer"
                                    )}
                                    onClick={() => {
                                      window.open(
                                        `/sp-profile/${item?.participant?.uuid}`,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    <img
                                      className={classNames(
                                        "mr-3 h-8 w-8 text-white"
                                      )}
                                      aria-hidden='true'
                                      src={Xero}
                                      alt='Export To Xero'
                                    />
                                    <div className='flex space-x-2 items-center'>
                                      <span className='text-blue-700 hover:underline'>
                                        Connect Xero
                                      </span>
                                      <span className='text-blue-600'>
                                        <FiArrowUpRight />
                                      </span>
                                    </div>
                                  </span>
                                  {/* </PopoverContainer> */}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </ModalSkeleton>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  getParticipantList: getSPParticipantsListRequest,
};

const mapStateToProps = (state) => {
  const spParticipants = getParticipantsList(state);
  const participantUpdatePusherReceived =
    getParticipantUpdatePusherReceivedSelector(state);

  return {
    spParticipants,
    participantUpdatePusherReceived,
    settings: getSpSetting(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RosterInvoicing);
